module.exports = __webpack_public_path__ + "img/discovery.a51dea49.svg";